( function () {
   
    'use strict';

    ( function ( $ ) {
       
        $(".register-next-btn a").click(function(){
            $(".register-form-detail-one").hide();
            $(".register-form-detail-two").show();
            $(".register-tab li.two").addClass("active");
        });
        $(".back-next-btn a.back").click(function(){
            $(".register-form-detail-one").show();
            $(".register-form-detail-two").hide();
            $(".register-tab li.two").removeClass("active");
        });
        $(".back-next-btn a.button.button-pink-btn").click(function(){
            $(".register-form-detail-one").hide();
            $(".register-form-detail-two").hide();
            $(".register-authorization").show();
            $(".register-account").addClass("active")
        });
    } )( jQuery );
} )();

